import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordinal'
})
export class OrdinalPipe implements PipeTransform {

  private readonly special: Record<number, string> = {
    1: 'First',
    2: 'Second',
    3: 'Third',
    4: 'Fourth',
    5: 'Fifth',
    6: 'Sixth',
    7: 'Seventh',
    8: 'Eighth',
    9: 'Ninth',
    10: 'Tenth',
    11: 'Eleventh',
    12: 'Twelfth',
    13: 'Thirteenth',
    14: 'Fourteenth',
    15: 'Fifteenth',
    16: 'Sixteenth',
    17: 'Seventeenth',
    18: 'Eighteenth',
    19: 'Nineteenth'
  };

  private readonly tens: Record<number, string> = {
    20: 'Twentieth',
    30: 'Thirtieth',
    40: 'Fortieth',
    50: 'Fiftieth',
    60: 'Sixtieth',
    70: 'Seventieth',
    80: 'Eightieth',
    90: 'Ninetieth'
  };

  private readonly unitSuffix: Record<number, string> = {
    1: 'First',
    2: 'Second',
    3: 'Third',
    4: 'Fourth',
    5: 'Fifth',
    6: 'Sixth',
    7: 'Seventh',
    8: 'Eighth',
    9: 'Ninth'
  };

  transform(value: number): string {
    if (!Number.isInteger(value) || value <= 0) {
      return '';
    }

    // 1–19
    if (this.special[value]) {
      return this.special[value];
    }

    // Exact tens (20, 30, ...)
    if (this.tens[value]) {
      return this.tens[value];
    }

    // 21–99 (Twenty-first, Thirty-second, etc.)
    if (value < 100) {
      const ten = Math.floor(value / 10) * 10;
      const unit = value % 10;

      if (this.tens[ten] && this.unitSuffix[unit]) {
        return `${this.tens[ten].replace('ieth', 'y')}-${this.unitSuffix[unit].toLowerCase()}`;
      }
    }

    // Fallback: numeric ordinal (101st, 112th, etc.)
    return this.numericOrdinal(value);
  }

  private numericOrdinal(value: number): string {
    const lastTwo = value % 100;

    if (lastTwo >= 11 && lastTwo <= 13) {
      return `${value}th`;
    }

    switch (value % 10) {
      case 1: return `${value}st`;
      case 2: return `${value}nd`;
      case 3: return `${value}rd`;
      default: return `${value}th`;
    }
  }
}
